export function variableParser(
  content: string,
  varibleData: Record<string, any> = {},
  replaceWith: string | null = null,
  salesForcePayload?: Record<string, any>,
): string {
  let result: string = content;
  const reg = RegExp("{[^{}]*}", "g");
  let arr: RegExpExecArray | null;

  while ((arr = reg.exec(content))) {
    const variableName = arr[0].slice(1, -1).trim();

    let variableValue = salesForcePayload
      ? salesForcePayload[variableName]
      : undefined;

    if (
      variableValue &&
      typeof variableValue === "string" &&
      variableValue.includes("{") &&
      variableValue.includes("}")
    ) {
      const innerVariableName = variableValue.slice(1, -1).trim();
      variableValue =
        varibleData[innerVariableName] !== undefined
          ? varibleData[innerVariableName]
          : variableValue;
    }

    if (variableValue === undefined) {
      variableValue = varibleData[variableName];
    }

    if (variableValue === undefined) {
      variableValue =
        Object.values(salesForcePayload || {}).find(
          (val) => val === variableName,
        ) || Object.values(varibleData).find((val) => val === variableName);
    }

    if (variableValue === undefined) {
      if (replaceWith === null) continue;
      variableValue = replaceWith;
    }

    const variableNameRegex = new RegExp(
      `{\\s*${variableName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*}`,
    );
    result = result.replace(variableNameRegex, String(variableValue));
  }

  return typeof result === "string" ? result.trim() : result;
}
